import React from 'react';
import PerformanceCurves from './performance-curves';
import Textarea from '../../common/textarea';

const WellSurvey: React.FC = () => {

    return (
        <div className='flex flex-col justify-center item-center w-full gap-[16px]'>
            <PerformanceCurves />
        </div>
    );
};

export default WellSurvey;
